// Composable
import { ref, onMounted, onUnmounted } from 'vue'
import { Tooltip } from "bootstrap";


/*
* Enable bootstrap 5 tooltips in component template.
*/
export function useTooltip() {
	let tooltips = ref(new Array())
	onMounted(() => {
		// Bind tooltip animations
		const tooltipTriggerList = Array.from(
			document.querySelectorAll("[data-bs-toggle='tooltip']")
		);

		tooltipTriggerList.forEach(tooltipTriggerEl => {
			let tooltipInstance = new Tooltip(tooltipTriggerEl);
			tooltips.value.push(tooltipInstance);
		});

		return tooltips
	});

	onUnmounted(() => {
		// Hide all tooltips
		tooltips.value.forEach(tooltipInstance => {
			tooltipInstance.dispose();
		});
	});

	return tooltips
}